import { render, staticRenderFns } from "./Breadcrumbs2.vue?vue&type=template&id=21b6a0a1&scoped=true&"
import script from "./Breadcrumbs2.vue?vue&type=script&lang=js&"
export * from "./Breadcrumbs2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b6a0a1",
  null
  
)

export default component.exports